import { render, staticRenderFns } from "./CmgNutritionCalculatorEntreeSelector.vue?vue&type=template&id=e8bca86e&scoped=true&lang=pug"
import script from "./cmg-nutrition-calculator-entree-selector.ts?vue&type=script&lang=ts&external"
export * from "./cmg-nutrition-calculator-entree-selector.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNutritionCalculatorEntreeSelector.vue?vue&type=style&index=0&id=e8bca86e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bca86e",
  null
  
)

export default component.exports